<p-dialog
    [(visible)]="isModalDisplayed"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
    appendTo="body"
    (onHide)="handleOnCancel()"
    [closable]="false"
    styleClass="custom-create-publication-modal"
>
    <p-header>
        <span class="d-none d-md-flex">{{ title }}</span>
        <div class="d-flex d-md-none justify-content-between">
            <div class="d-flex">
                <button
                    *ngIf="publicationSlidePanel.activePanelPosition === 'CENTER'"
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-times"
                    class="p-button-secondary p-button-text"
                    (click)="handleOnCancel()"
                ></button>
                <button
                    *ngIf="publicationSlidePanel.activePanelPosition !== 'CENTER'"
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-arrow-left"
                    class="p-button-text p-button-secondary"
                    (click)="publicationSlidePanel.slideToCenter()"
                ></button>
            </div>
            <div class="d-flex">
                <ng-container *ngTemplateOutlet="buttons"> </ng-container>
            </div>
        </div>
        <p-divider class="d-flex d-md-none"></p-divider>
    </p-header>

    <wudo-slide-panel #publicationSlidePanel [animationEnabled]="false">
        <div
            centerPanel
            class="p-d-flex p-flex-column p-px-2 p-mt-2"
            style="max-width: 1033px"
            *ngIf="publicationSlidePanel.activePanelPosition === 'CENTER'"
        >
            <form>
                <div class="user-information-frame">
                    <p-avatar
                        [image]="currentUser.pictureReference"
                        styleClass="comment-profile-picture avatar"
                        size="large"
                        shape="circle"
                        [style]="{ 'background-color': 'var(--gray-light)' }"
                        [label]="!currentUser.pictureReference ? currentUser.firstName.slice(0, 1) + currentUser.lastName.slice(0, 1) : ''"
                    ></p-avatar>
                    <div class="publication-information ps-2" *ngIf="(!isAdmin() && !isAnim()) || isEditMode">
                        <div class="d-flex align-items-center">
                            <div>
                                <div class="fw-bold">{{ currentUser.firstName }} {{ currentUser.lastName }}</div>
                                <div class="text-muted">{{ currentClubTitle }} ▸ {{ currentRoomTitle }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="publication-information p-ml-2" *ngIf="(isAdmin() || isAnim()) && !isEditMode">
                        <div class="username">{{ currentUser.firstName }} {{ currentUser.lastName }}</div>
                        <div>
                            <span class="room-selection-label">{{ 'clubs.page.common.createPublication.button.in' | translate }}</span>
                            <button
                                pButton
                                pRipple
                                [icon]="'pi pi-chevron-down'"
                                iconPos="right"
                                type="button"
                                [label]="
                                    getTotalSelectedRooms() === 0
                                        ? ' ' + ('clubs.page.common.createPublication.rooms.empty' | translate)
                                        : getTotalSelectedRooms() + ' ' + (getTotalSelectedRooms() | i18nPlural : roomMessageMapping)
                                "
                                class="p-button-secondary p-button-rounded small-button inline-text-button"
                                (click)="publicationSlidePanel.slideToRight()"
                            ></button>
                            <span class="room-selection-label">{{ 'clubs.page.common.createPublication.button.from' | translate }}</span>
                            <button
                                pButton
                                pRipple
                                [icon]="'pi pi-chevron-down'"
                                iconPos="right"
                                type="button"
                                [label]="
                                    getSelectedClubCount() === 0
                                        ? ' ' + ('clubs.page.common.createPublication.clubs.empty' | translate)
                                        : getSelectedClubCount() + ' ' + (getSelectedClubCount() | i18nPlural : clubMessageMapping)
                                "
                                class="p-button-secondary p-button-rounded small-button inline-text-button"
                                (click)="publicationSlidePanel.slideToRight()"
                            ></button>
                        </div>
                    </div>
                </div>
                <div class="input-information-frame">
                    <div class="length-information">{{ contentLength }}/{{ PUBLICATION_CONTENT_MAX_LENGTH }}</div>
                </div>
                <div class="publication-frame">
                    <quill-editor
                        #newPublicationQuillEditor
                        id="content"
                        [formControl]="form.controls.content"
                        placeholder="{{ 'clubs.page.tabs.discussion.post.placeholder' | translate }}"
                        theme="snow"
                        required="true"
                        [modules]="isEditingComment ? publicationQuillEditorHelper.noToolbar : publicationQuillEditorHelper.modulesForClubPosts"
                        [formats]="quillEditorHelper.formats"
                        (paste)="handlePaste($event)"
                        [mention]="members"
                        [mentionConfig]="{ dropUp: false, appendTo: 'parent' }"
                        (mentionSelectedEvent)="onMentionSelected($event)"
                        (keydown)="onKeydown($event)"
                        (opened)="onMentionListOpen()"
                        (closed)="onMentionListClosed()"
                        (dragover)="handleDragOver($event)"
                        (dragenter)="handleDragEnter($event)"
                        (drop)="handleDrop($event)"
                    >
                    </quill-editor>

                    <div class="row">
                        <div *ngIf="isPortraitChallengeAvailable" class="col">
                            <button
                                *ngIf="!isTextShown"
                                pButton
                                type="button"
                                label="{{ 'clubs.page.tabs.discussion.post.displayPortaitChallenge' | translate }}"
                                class="p-button-outlined p-mt-1 p-mb-2"
                                (click)="addPortraitChallengeToTextArea()"
                            ></button>
                            <button
                                *ngIf="isTextShown"
                                pButton
                                type="button"
                                label="{{ 'clubs.page.tabs.discussion.post.hidePortaitChallenge' | translate }}"
                                icon="pi pi-times"
                                iconPos="right"
                                class="p-mt-1 p-mb-2"
                                (click)="clearTextArea()"
                            ></button>
                        </div>
                        <div class="col">
                            <div class="buttons" style="display: flex; justify-content: flex-end">
                                <button
                                    class="picker-button"
                                    title="{{ 'clubs.page.tabs.discussion.post.emoji' | translate }}"
                                    (click)="handleEmojiPickerButtonClick()"
                                >
                                    <i class="icon-o-smile custom-icon"></i>
                                </button>
                                <label for="file"></label>
                                <input
                                    [formControl]="form.controls.image"
                                    #imageInput
                                    type="file"
                                    accept="image/*"
                                    style="display: none"
                                    (change)="updateImage($event)"
                                />
                                <button
                                    *ngIf="!urlLink && !LocalDocument"
                                    class="picker-button"
                                    (click)="imageInput.click()"
                                    title="{{ 'clubs.page.tabs.discussion.post.image' | translate }}"
                                >
                                    <i class="icon-picture custom-icon"></i>
                                </button>
                                <input
                                    [formControl]="form.controls.document"
                                    #documentInput
                                    type="file"
                                    accept=".doc,.docx,.pdf,.ppt,.pptx,.xls,.xlsx"
                                    style="display: none"
                                    multiple="false"
                                    (change)="updateDocument($event)"
                                />
                                <button
                                    *ngIf="!urlLink && !localImageSrc && !LocalDocument && (isAdmin() || isAnim())"
                                    class="picker-button"
                                    (click)="documentInput.click()"
                                    title="{{ 'clubs.page.tabs.discussion.post.document' | translate }}"
                                >
                                    <i class="icon-file-empty custom-icon"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div
                        class="emoji-container"
                        [ngClass]="{
                            'publication-emoji-container-transform': !isEditingComment,
                            'comment-emoji-container-transform': isEditingComment
                        }"
                    >
                        <emoji-mart
                            #emojiPicker
                            *ngIf="isEmojiPickerVisible"
                            class="emoji-picker-container"
                            title="{{ 'clubs.page.tabs.discussion.post.selectEmoji' | translate }}"
                            [darkMode]="false"
                            [i18n]="emojiTranslations"
                            [skin]="2"
                            [isNative]="true"
                            color="var(--primary-background)"
                            [hideObsolete]="false"
                            [showPreview]="false"
                            [showSingleCategory]="true"
                            (emojiSelect)="addEmojiToContent($event)"
                        ></emoji-mart>
                    </div>
                    <wudo-spinner *ngIf="isLinkLoading"></wudo-spinner>
                    <div *ngIf="urlLink" class="url-container">
                        <ng-container *ngIf="!isLinkLoading">
                            <app-link-preview [link]="urlLink" class="p-mt-4"></app-link-preview>
                            <button
                                pButton
                                pRipple
                                type="button"
                                icon="pi pi-times"
                                class="p-button-rounded p-button-danger remove-button"
                                (click)="handleRemoveUrlLink()"
                            ></button>
                        </ng-container>
                    </div>
                    <div *ngIf="localImageSrc || this.cropperParams?.urlImage" class="image-container">
                        <image-cropper-old
                            *ngIf="localImageSrc || this.cropperParams?.urlImage"
                            style="width: auto"
                            [format]="'png'"
                            [imageChangedEvent]="imageService.imageChangedEvent"
                            [imageBase64]="localImageSrc"
                            [imageURL]="cropperParams.urlImage"
                            [maintainAspectRatio]="cropperParams.isRatioFix"
                            [containWithinAspectRatio]="imageService.containWithinAspectRatio"
                            [aspectRatio]="cropperParams.ratio"
                            [cropperMinWidth]="cropperParams.minWidth"
                            [cropperMinHeight]="cropperParams.minHeight"
                            [onlyScaleDown]="true"
                            [roundCropper]="false"
                            [canvasRotation]="imageService.canvasRotation"
                            [alignImage]="cropperParams.alignImage"
                            [style.display]="null"
                            [resizeToWidth]="cropperParams.resizeToWidth"
                            [resizeToHeight]="cropperParams.resizeToHeight"
                            (imageCropped)="imageHasBeenCropped($event)"
                            (imageLoaded)="imageService.imageLoaded()"
                            (loadImageFailed)="imageService.loadImageFailed()"
                        ></image-cropper-old>
                        <button
                            *ngIf="localImageSrc || this.cropperParams?.urlImage"
                            pButton
                            pRipple
                            type="button"
                            icon="pi pi-times"
                            class="p-button-rounded p-button-danger remove-button"
                            (click)="handleRemoveImage()"
                        ></button>
                    </div>
                    <div *ngIf="LocalDocument" class="resource-frame ressource-file p-mt-4 p-p-3">
                        <label class="content-label p-mb-0">{{ LocalDocument.name }}</label>

                        <div class="content-label p-ml-auto remove-file" (click)="removeFile()">
                            {{ 'clubs.page.tabs.resources.create.deleteFile' | translate }}
                        </div>
                    </div>
                </div>
                <div *ngIf="form.controls.content.invalid && (form.controls.content.dirty || form.controls.content.touched)">
                    <div class="danger-text p-mx-2" *ngIf="contentLength > PUBLICATION_CONTENT_MAX_LENGTH">
                        {{
                            'clubs.page.tabs.discussion.post.textLengthValidator'
                                | translate : { publicationContentMaxLength: PUBLICATION_CONTENT_MAX_LENGTH, currentTextLength: contentLength }
                        }}
                    </div>
                </div>

                <div class="input-information-frame" *ngIf="canUserCreateAnnouncement">
                    <label class="p-mr-2 p-my-1">{{ 'clubs.page.tabs.discussion.post.createAnnouncement' | translate }}</label>
                    <i class="icon-f-bell announcement-icon p-my-1"></i>
                    <p-inputSwitch
                        (onChange)="changeAnnouncementValue()"
                        [(ngModel)]="isAnAnnouncement"
                        name="announcement"
                        class="p-ml-2"
                    ></p-inputSwitch>
                </div>
                <div class="input-information-frame" *ngIf="canUserCreateAnnouncement">
                    <label class="announcement-details-label">{{ announcementMessage }}</label>
                </div>
            </form>
        </div>
        <div rightPanel class="p-d-flex p-flex-column p-px-2">
            <app-select-rooms-accordion
                [defaultRoomId]="clubsStore.displayedRoomId"
                [clubId]="clubsStore.displayedClubId"
                [isModalOpen]="isModalDisplayed"
                [isVisible]="publicationSlidePanel.activePanelPosition !== 'CENTER'"
            >
            </app-select-rooms-accordion>
        </div>
    </wudo-slide-panel>

    <p-footer *ngIf="!isMobile">
        <button
            *ngIf="publicationSlidePanel.activePanelPosition !== 'CENTER'"
            type="button"
            class="p-button-text p-button"
            (click)="publicationSlidePanel.slideToCenter()"
        >
            {{ 'components.button.back' | translate }}
        </button>
        <button
            *ngIf="publicationSlidePanel.activePanelPosition === 'CENTER'"
            pButton
            pRipple
            type="button"
            class="p-button-text p-button"
            label="{{ 'components.button.buttonCancel' | translate }}"
            (click)="handleOnCancel()"
        ></button>
        <ng-container *ngTemplateOutlet="buttons"> </ng-container>
    </p-footer>
</p-dialog>

<div
    *ngIf="!isEditMode"
    class="create-publication-modal-button d-none d-md-flex"
    (click)="!clubsStore.isLoadingMembers && openModal()"
    [ngClass]="{ disabled: !canUserPublish || clubsStore.isLoadingMembers }"
>
    <div class="content">
        <ng-content></ng-content>
    </div>
</div>

<button
    *ngIf="!isEditMode"
    pButton
    class="d-md-none p-button-outlined ml-2 px-custom"
    icon="pi pi-pencil"
    (click)="openModal()"
    [ngClass]="{ disabled: !canUserPublish }"
></button>

<ng-template #buttons>
    <ng-container>
        <button
            pButton
            pRipple
            class="p-button"
            style="z-index: 1"
            type="button"
            [label]="action"
            (click)="handleOnSubmit()"
            [disabled]="!form.valid || submitted"
        ></button>
    </ng-container>
</ng-template>
